module.exports = __webpack_public_path__ + "static/media/rpm_img2.2f4e759d.svg";